import { noOpStrategy } from '../strategies';
var PersistentStorageStrategyFactory = /** @class */ (function () {
    function PersistentStorageStrategyFactory() {
        this.strategies = [];
    }
    PersistentStorageStrategyFactory.prototype.register = function (strategy) {
        this.strategies.push(strategy);
    };
    /**
     * get first accessible registered strategy or return noOp strategy if none found
     */
    PersistentStorageStrategyFactory.prototype.getStrategy = function () {
        var _a;
        return ((_a = this.strategies.find(function (strategy) { return strategy.isSupported(); })) !== null && _a !== void 0 ? _a : noOpStrategy);
    };
    return PersistentStorageStrategyFactory;
}());
export { PersistentStorageStrategyFactory };
